// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3cUK7","selected":"Chip_selected__b1T8P"};